import React, { createContext, useContext, useEffect, useState } from "react";
import api from "./lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=none, obj=logged in
  const [session, setSession] = useState(undefined);

  const loadSession = async () => {
    try {
      const { data } = await api.get("/session/today");
      setSession(data || null);
    } catch { setSession(null); }
  };

  useEffect(() => {
    const token = localStorage.getItem("apto_token");
    if (!token) { setUser(false); return; }
    api.get("/auth/me")
      .then(({ data }) => { setUser(data); loadSession(); })
      .catch(() => { localStorage.removeItem("apto_token"); setUser(false); });
  }, []);

  const login = (token, u) => {
    localStorage.setItem("apto_token", token);
    setUser(u);
    loadSession();
  };
  const logout = () => {
    localStorage.removeItem("apto_token");
    setUser(false);
    setSession(undefined);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, session, setSession, loadSession, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
